module.exports = __webpack_public_path__ + "images/Arrow-right.6fe47358b9cacfd8ca1f02665e0618e8.svg";